import React from 'react';
import { CardActionArea } from '@material-ui/core';
const CardContentWrapper = ({ children, onClick }) => (onClick ? (React.createElement(CardActionArea, { onClick: onClick }, children))
    : React.createElement(React.Fragment, null, children));
export default CardContentWrapper;
